import type { StatsSnapshot } from '../../../stats/gameplay-snapshot';
import { useCurrencyStore } from '../../zustand/useCurrencyStore';
import { useGameStatsStore } from '../../zustand/useGameStatsStore';

export const minerReducer = (scratch: StatsSnapshot) => {
  const miner = scratch.generators.miner;

  // Only update if ticksCount is a multiple of ticksToGenerate
  const ticksToGenerate = miner.ticksToGenerate ?? 1;
  if (useGameStatsStore.getState().getActiveTicksCount() % ticksToGenerate !== 0) {
    return;
  }

  const oreGenerated = miner.owned * miner.baseGeneration;

  // Apply upgrades somehow, somewhere...

  useCurrencyStore.getState().addOre(oreGenerated);

  return;
};
